import React from "react";
import "./header.scss";

const header = () => {
  return (
    <div className="container-header">
      <div className="title-header">
        <h2>MITRA PEMASARAN SUMMARECON BEKASI</h2>
        <p>Konsultan Properti Independen - +6289510613901</p>
      </div>
    </div>
  );
};

export default header;
